import React, { useState } from "react";
import { Link } from "react-router-dom";
import { urlApi } from "../../lib/api";

/**
 * Nom de la synagogue (et son logo s'il existe) en tête de la page campagne :
 * le donateur voit tout de suite À QUI il donne. Le nom mène à la page
 * publique de la synagogue (ses autres campagnes).
 *
 * Le logo est servi par l'API à une adresse versionnée (cache d'un an) :
 * adresse ABSOLUE via urlApi, taille fixe (aucun saut de page à son
 * arrivée) ; s'il ne charge pas, le nom reste seul — jamais d'icône cassée.
 */
export default function SynagogueCampagne({ nom, logoUrl, orgId }) {
  const [logoEchoue, setLogoEchoue] = useState(false);
  if (!nom) return null;
  const src = logoUrl && !logoEchoue ? urlApi(logoUrl) : null;
  const contenu = (
    <>
      {src && (
        <img
          src={src}
          alt=""
          width={32}
          height={32}
          decoding="async"
          onError={() => setLogoEchoue(true)}
          className="h-8 w-8 shrink-0 rounded-full object-contain bg-white border border-stone-200"
        />
      )}
      <span className="min-w-0 truncate text-sm font-medium text-stone-600">{nom}</span>
    </>
  );
  return (
    <div className="mb-5 flex justify-center" data-testid="synagogue-campagne">
      {orgId ? (
        <Link to={`/organisations/${orgId}`}
          className="inline-flex max-w-full items-center gap-2.5 hover:underline underline-offset-4 decoration-stone-300">
          {contenu}
        </Link>
      ) : (
        <span className="inline-flex max-w-full items-center gap-2.5">{contenu}</span>
      )}
    </div>
  );
}
